export interface PhaseRoot {
  '@odata.context': string;
  value: Phase[];
}

export interface Phase {
  '@odata.etag': string;
  projectNo: string;
  phaseNo: string;
  phaseName: string;
  phaseDescription: string;
  phaseStartDate: string;
  phaseEndDate: string;
  phaseMinEstHours: number;
  phaseMaxEstHours: number;
  actualHours: number;
  phasePercentComplete: number;
  workItemId?: number | null;
}

export class PhasesDomain {
  newPhases: Phase[];

  constructor(newPhases?: Phase[]) {
    this.newPhases = newPhases ?? [];
  }

  toJsonList(currentPhases: Record<string, Phase>): Record<string, Phase> {
    this.newPhases.forEach((phase) => {
      if (phase.phaseNo) {
        currentPhases[phase.phaseNo] = phase;
      }
    });

    return currentPhases;
  }

  toList(currentPhases: Record<string, Phase>): Phase[] {
    return Object.values(currentPhases);
  }
}
